export default __webpack_public_path__ + "static/media/Hector Marin.4a71fd6f.jpg";